// extracted by mini-css-extract-plugin
module.exports = {"errorMessageHolder":"ErrorMessage_errorMessageHolder__2ZX4a"};